<template>
    <div class="page">
        <div id="copycontent" class="type8">
            <section class="content">
                <!--                    <p class="innerTitle"><span>My CEO Stepbrother Kissed me</span></p>-->
                <section class="boxbr" v-html="bookCon">
                    {{bookCon}}
                </section>
                <p v-if="bookCon != ''" class="tipInfo">Install <b>Meetnovel</b> and enter [<b>{{copyCon}}</b>] to read the full version</p>
                <div class="center" v-if="bookCon != ''">
                    <a class="download-btn" :data-clipboard-text="`haiwen_${copyCon}`" @click="downlowFun('andriod')" href="javascript:void(0);"><img src="../../assets/account/btn_android.png"/></a>
<!--                    <a class="download-btn" :data-clipboard-text="`haiwen_${copyCon}`" @click="downlowFun('ios')" href="javascript:void(0);"><img src="../../assets/account/btn_iphone.png"/></a>-->
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import "utils/lib/rem";
    import Clipboard from 'clipboard'
    import { extensionDetail,adminNoticecontent } from "apiurl/extension";
    export default {
        name: "",
        data () {
            return {
                copyCon: '24',
                bookName: '马甲',
                bookCon: '',
            }
        },
        mounted () {
            // if (this.$route.query.num) {
            //     this.copyCon = this.$route.query.num
            //     this.bookName = this.$route.query.name
            // }
            this.getCon()
        },
        methods: {
            async getCon () {
                let res = await adminNoticecontent({id: this.$route.params.id, delCache: 1});
                if (res.success) {
                    this.bookCon = res.data.noticeContent
                    this.copyCon = res.data.tagNum
                    this.bookName = res.data.noticeTitle
                    document.title = this.bookName
                    this.getDetail(this.bookName, 'load')
                }
            },
            async getDetail (name, action) {
                let res = await extensionDetail(name, action);
            },
            copy () {
                var clipboard = new Clipboard('.download-btn')
                clipboard.on('success', e => {
                    console.log('复制成功')
                    //  释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e =>{
                    // 不支持复制
                    console.log('该浏览器不支持复制')
                    // 释放内存
                    clipboard.destroy()
                })
            },
            downlowFun (flag) {
                // this.copy()
                // fbq('track', 'Purchase', {currency: "USD", value: 1.00});
                if (flag == 'andriod') {
                    this.getDetail(this.bookName, 'click')
                    window.location.href = 'https://play.google.com/store/apps/details?id=com.meetnovel.study'
                } else {
                    // this.getDetail(this.bookName, 'click')
                    window.location.href = 'https://apps.apple.com/us/app/meetnovel/id1628470640'
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "../../styles/type8";
    html{
        -moz-user-select:none;
        -webkit-user-select:none;
        user-select:none;
    }
    .page{
        width: 100%;
        height: auto;
        background: #fff;
    }
    .center{
        display: inline-block;
        width: 100%;
        margin: auto;
        margin-bottom: 20px;
        .download-btn {
            display: block;
            width: 100%;
            float: left;
            text-align: center;
            img{
                width: 168px;
                height: 44px;
            }
        }
    }
</style>
